/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import AdminLoginForm from '../../../common/login/login-form';
import { isAdminLoggedIn, isAuditorLoggedIn } from '../../../../utils/tokenUtils';
import { adminLogin } from '../../../../actions/login';

import './login.css';

export default class AdminLogin extends Component {
  render() {
    if (isAdminLoggedIn()) {
      const path = isAuditorLoggedIn() ? '/admin/audit/submissions/next' : '/admin/my-profile';

      return <Redirect to={path} />;
    }

    return (
      <div className="row">
        <div className="col-md-5 col-md-offset-1">
          <AdminLoginForm type={this.props.area} loginAction={adminLogin}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/login/login-page/index.jsx